// extracted by mini-css-extract-plugin
export default {"container":"ZdjW4bIghskVrJOre8rG","overflowLeft":"KKJYnwUaJy8Y5w0GPQ1t","overflowRight":"VoRBcjNjfgENG2JxxPae","useShadow":"G5hg0XstfHsntiTrZME3","border":"HlziETQ5F3_whZfjUT1z"};